import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';

import * as serviceWorker from './serviceWorker';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { App } from './App';

import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { store, rrfProps } from './store'
ReactDOM.render(
  <React.StrictMode>
    <Provider store={ store }>
      <BrowserRouter>
        <ReactReduxFirebaseProvider {...rrfProps} >
          <App />
        </ReactReduxFirebaseProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
